import { Component, AfterViewInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import * as $ from 'jquery';

@Component({
  selector: 'app-build-number',
  templateUrl: './build-number.component.html',
  styleUrls: ['./build-number.component.scss']
})
export class BuildNumberComponent implements AfterViewInit {
	constructor(
		private cookieService: CookieService
	){}
	
	attempt:number = 1

	ngAfterViewInit() {
		this.setBuildHeader()
	}

	setBuildHeader(){
		setTimeout(() => {
			if ( jQuery('body>#ahec-menu-bar>div').length > 0 ) {
				let host = window.location.hostname

				if (host.startsWith("dev.") || host.startsWith("stage.") || host.indexOf("localhost") > -1) {
					let application = this.cookieService.get("app");
					let label = (window.location.hostname === 'localhost') ? 'ncahec/courses (local development)' : application
					jQuery('body>#ahec-menu-bar>div').prepend(`<div id="image-config">${label}</div>`)
				}
			} else if ( this.attempt < 20) {
				this.attempt += 1
				this.setBuildHeader()
			}
		}, 200)
	}
}
